import type { SVGProps } from "react";
const SvgCommunityPostTypeQuestion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 15 13"
    fontSize="1rem"
    {...props}
  >
    <g clipPath="url(#community-post-type-question_svg__a)">
      <path
        fill="#46D7AE"
        d="M13.457 2.507C13.223 1.45 12.198.482 11.138.277 10.493.146 8.691-.014 7.5 0 6.308-.012 4.507.147 3.86.276 2.8.482 1.777 1.45 1.543 2.507a13 13 0 0 0-.266 2.707 13 13 0 0 0 .266 2.707c.234 1.057 1.259 2.026 2.319 2.231.349.07 1.034.149 1.779.204q.126.2.275.423c.395.598.697 1.015.926 1.306.381.483.936.483 1.317 0 .23-.29.532-.708.927-1.306q.148-.224.275-.423c.744-.055 1.43-.134 1.779-.204 1.06-.205 2.085-1.174 2.319-2.23.133-.643.264-1.516.266-2.708a13 13 0 0 0-.266-2.706m-5.27 6.321a.4.4 0 0 1-.309.309c-.09.015-.212.029-.379.029-.166 0-.289-.014-.379-.03a.4.4 0 0 1-.308-.308 2.3 2.3 0 0 1-.03-.379c0-.167.015-.289.03-.379a.4.4 0 0 1 .308-.308c.09-.015.212-.03.38-.03.166 0 .288.015.378.03a.4.4 0 0 1 .309.308c.015.09.029.212.03.38 0 .166-.015.288-.03.378m1.48-3.982c-.188.266-.469.508-.885.763-.527.325-.611.458-.611.72v.103a.673.673 0 0 1-1.344 0v-.24c0-.308.077-.57.235-.8.154-.222.384-.42.726-.623.63-.37.744-.578.744-.854 0-.347-.295-.57-.752-.57-.5 0-.827.227-.969.676a.71.71 0 0 1-.735.493.716.716 0 0 1-.633-.932c.153-.477.447-.874.85-1.149.407-.277.921-.424 1.487-.424s1.133.188 1.535.528c.415.35.643.833.643 1.36 0 .362-.095.672-.291.95"
      />
    </g>
    <defs>
      <clipPath id="community-post-type-question_svg__a">
        <path fill="#fff" d="M0 0h15v12.447H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCommunityPostTypeQuestion;
